// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

/**
 * Documenter "Mode". Determines the shape of the output, including what does or does not get processed.
 */
 export enum DocGenMode {
    /**
     * Generates documentation for all exported API members
     */
    Full = "full",

    /**
     * Generates the package summary documentation only
     * (i.e. the notes associated with the `@packageDocumentation` comment in the package's root export)
     */
    PackageSummaries = "package-summaries",
}